export default __webpack_public_path__ + "static/media/pause-video.34ba512a.png";